// frontend/src/components/guide/GuideErrorBoundary.js
//
// Isolates the feature guide from the rest of the app: if a malformed content
// step or a render bug throws, the guide silently disappears instead of taking
// down the authenticated shell around it. The guide is non-critical, so the
// graceful failure mode is "no guide", not an error screen.

import React from "react";

class GuideErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // No PII in guide rendering; safe to log for debugging.
    // eslint-disable-next-line no-console
    console.error("FeatureGuide render error — guide hidden:", error, info?.componentStack);
    // Let the parent reset its open state so a stale-open guide can't get stuck.
    this.props.onError?.();
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

export default GuideErrorBoundary;
